// Mount the Kubernetes module: hand `createKubernetesModule` a lazy host (`./kubernetes-host`, which holds the
// heavy app imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the routes and
// the catalog scope from HERE, so the module cannot be mounted unregistered. Two pages render things of the
// module outside its consoles and may not import a package or this file, so the root hands them loaders:
// the catalog detail page reads `catalogLandings.loadKubernetesLanding`, and the Organizations console reads
// `k8sSlots` (`@vnetwork/margarita-shell/k8s-slots`): the cluster list of a project, the cluster picker of a
// grant and where a cluster opens. This file must stay light: it is in the entry chunk, so the Kubernetes
// consoles are behind dynamic imports, never imported statically here. The HTTP clients are not members: the
// data layer reads the shared registry (`@vnetwork/margarita-core/http`).
import { lazy } from 'react';
import { k8sSlots } from '@vnetwork/margarita-shell/k8s-slots';
import { catalogLandings } from '@/components/catalog-landings';
import { env } from '@/config/env';
import { paths } from '@/lib/paths';
import { createKubernetesModule } from '@vnetwork/margarita-kubernetes';

export const kubernetes = createKubernetesModule(() => import('./kubernetes-host').then((m) => m.kubernetesHost), {
  v2Enabled: !!env.k8sV2ApiUrl,
});

catalogLandings.loadKubernetesLanding = kubernetes.loadActivateLanding;
k8sSlots.ProjectClusters = lazy(kubernetes.loadProjectClusters);
k8sSlots.ClusterScopePicker = lazy(kubernetes.loadClusterScopePicker);
k8sSlots.clusterPath = paths.kubernetes.v2.cluster;
